


























import VueOptions from '@utils/VueOptions'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RecapHeader'

  vue:
    props: ['recap']

    computed:
      offer: ->
        @recap.ctx.offer

      listing: ->
        @recap.ctx.listing

      dates: ->
        { start_date, end_date } = @recap
        @$options.filters.formatDateWindow start_date, end_date

export default VueOptions.vue settings
